import { initDB } from "./index";
import { STORE_NAME } from "./dbConfig";

// Get data from IndexedDB
export const getDataFromDB = async (key) => {
  const db = await initDB();
  return await db.get(STORE_NAME, key);
};

// Set data into IndexedDB
export const setDataToDB = async (key, data) => {
  const db = await initDB();
  await db.put(STORE_NAME, data, key);
};

// Remove a specific item from IndexedDB
export const removeDataFromDB = async (key) => {
  const db = await initDB();
  await db.delete(STORE_NAME, key);
};

// Clear all data from IndexedDB
export const clearDB = async () => {
  const db = await initDB();
  await db.clear(STORE_NAME);
};
